import { IActivityConfiguration, IActivityTab } from '../../interfaces/IActivityComponent';
import { ActivityConfigurations } from '../../registries/activity-configurations';
import { ActivityType } from 'app/model/pipeline/activitytype';
import { Named } from 'app/model/base/named';
import { IModel } from 'app/model/base/annotation';

@ActivityConfigurations.register({})
export abstract class MappingActivityConfiguration implements IActivityConfiguration {
    public label: string;
    public name: string;
    public activityType: ActivityType;
    public dataMappingType: IModel;
    public iconClass: string;
    public iconTransform: string;
    public activityTabs: IActivityTab[];
    public hasRightIcon: boolean;
    public dataMappingNamePrefix?: string;

    public abstract isMappingAllowed(dataMapping: Named): boolean;
    public abstract getMappingProperty(dataMappingActivity: Named): Named | undefined;
    public abstract setMappingProperty(dataMappingActivity: Named, dataMapping?: Named): void;
}
